<template>
  <span
    v-if="!hasDismissed"
    class="onboarding-tooltip-anchor"
  >
    <slot />
    <q-tooltip
      v-model="visible"
      :anchor="anchor"
      :self="self"
      :offset="offset"
      :max-width="maxWidth"
      no-parent-event
      class="onboarding-tooltip"
    >
      <div class="row items-start no-wrap">
        <q-icon
          name="mdi-lightbulb-on-outline"
          size="18px"
          color="amber-4"
          class="q-mr-sm q-mt-xs"
        />
        <div class="col">
          <div
            v-if="title"
            class="text-bold q-mb-xs"
          >
            {{ title }}
          </div>
          <div class="text-caption">
            <slot name="content">
              {{ description }}
            </slot>
          </div>
        </div>
        <q-btn
          flat
          round
          dense
          size="xs"
          icon="mdi-close"
          color="white"
          class="q-ml-sm"
          @click="dismiss"
        />
      </div>
    </q-tooltip>
  </span>
</template>

<script>
import tipMixin from 'components/partials/tips/mixin'

export default {
  name: 'OnboardingTooltip',
  mixins: [tipMixin],
  props: {
    name: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    anchor: {
      type: String,
      default: 'bottom middle'
    },
    self: {
      type: String,
      default: 'top middle'
    },
    offset: {
      type: Array,
      default: () => [0, 8]
    },
    maxWidth: {
      type: String,
      default: '280px'
    },
    // Delay before showing (ms)
    showDelay: {
      type: Number,
      default: 500
    }
  },
  data () {
    return {
      visible: false,
      showTimer: null
    }
  },
  computed: {
    hasDismissed () {
      return this.baseHasDismissedTip(this.tipKey)
    },
    tipKey () {
      return `onboarding_tooltip_${this.name}`
    }
  },
  watch: {
    hasDismissed (val) {
      if (val) {
        this.visible = false
      }
    }
  },
  methods: {
    dismiss () {
      this.visible = false
      this.baseDismissTip(this.tipKey)
    }
  },
  mounted () {
    if (!this.hasDismissed) {
      this.showTimer = setTimeout(() => {
        this.visible = true
      }, this.showDelay)
    }
  },
  beforeUnmount () {
    if (this.showTimer) {
      clearTimeout(this.showTimer)
    }
  }
}
</script>

<style lang="scss">
.onboarding-tooltip {
  background: $blue-grey-9;
  border-radius: 8px;
  padding: 10px 12px;
}
</style>
